// @ts-nocheck
import React, { useState, useEffect } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import cssInJS from './css';
import { CheckIcon, CopyIcon } from '../icons';

interface Props {
  url: string;
}

type Timer = NodeJS.Timer | number;

const ShareLinkItem: React.FC<Props> = ({ url }: Props) => {
  const [copied, setCopied] = useState(false);
  let _copyTimer: Timer;

  useEffect(() => {
    _copyTimer = setTimeout(() => setCopied(false), 1000);

    // clears timer on unmount
    return () => clearTimeout(_copyTimer as number);
  }, [copied]);

  const handleCopy = () => {
    setCopied(true);
    clearTimeout(_copyTimer as number);
  };

  const tip = copied ? 'Copied!' : 'Copy to Clipboard';

  return (
    <div className={styles.inputContainer}>
      <input
        className={styles.input}
        value={copied ? tip : url}
        readOnly
      />
      <CopyToClipboard text={url} onCopy={handleCopy}>
        <div
          className={copied ? styles.clipBoardButtonActive : styles.clipBoardButton}
          title={tip}
        >
          {copied ? <CheckIcon className={styles.icon} /> : <CopyIcon className={styles.icon} />}
        </div>
      </CopyToClipboard>
    </div>
  );
};

const styles = cssInJS({
  inputContainer: {
    display: 'flex',
    marginBottom: 10,
  },
  input: {
    flex: 1,
    color: '#4baef8',
    padding: 4,
    width: '100%',
    border: '1px solid #ccc',
    borderRadius: '5px 0px 0px 5px',
    WebkitAppearance: 'none',
    height: 25,
  },
  clipBoardButtonActive: {
    transition: 'all .3s',
    cursor: 'pointer',
    border: '1px solid #4baef8',
    fill: '#fff',
    borderRadius: '0px 5px 5px 0px',
    backgroundColor: '#4baef8',
    textAlign: 'center',
    width: 30,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  clipBoardButton: {
    transition: 'all .3s',
    cursor: 'pointer',
    border: '1px solid #ccc',
    borderLeft: 'none',
    borderRadius: '0px 5px 5px 0px',
    backgroundColor: '#f4f4f4',
    textAlign: 'center',
    width: 30,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    width: 16,
    height: 16,
  },
});

export default ShareLinkItem;
